





















































import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import ImageSelector from "@/components/molecules/ImageSelector.vue";
import SelectBox from "@/components/molecules/SelectBox.vue";
import MultipleSelectBox from "@/components/molecules/MultipleSelectBox.vue";
import { submitImage } from "@/lib/image-save";
import { genre as genreList, category as categoryList, workStatus as workStatusList } from "@/lib/novelSettings";
import { Novel } from "@/lib/models";
import { Dialog } from "@/lib/utils";
import DialogVue from "@/components/ui/Dialog.vue";
import isMobile from "ismobilejs";

type NovelParam = {
  id: string;
  name: string;
  image: string;
};

interface Data {
  novel: Novel | null;
  image?: string;
  genre?: NovelParam | null;
  genreList: NovelParam[];
  category?: NovelParam[] | null;
  categoryList: NovelParam[];
  workStatus?: NovelParam | null;
  workStatusList: NovelParam[];
}

interface Methods {
  change(): void;
  initialize(): void;
  imagePath(): string | null;
  submit(): Promise<void>;
  selectGenre(item: NovelParam): void;
  selectCategory(items: NovelParam[]): void;
  selectWorkStatus(item: NovelParam): void;
  unselectGenre(): void;
  showErrorDialog(message: string): void;
}

interface Props {
  novelId: string;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    TextField,
    ImageSelector,
    SelectBox,
    MultipleSelectBox,
  },
  props: {
    novelId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      novel: null,
      image: undefined,
      genre: null,
      category: null,
      workStatus: workStatusList.find((x) => x.id === "inProgress"),
      genreList,
      categoryList,
      workStatusList,
    };
  },
  async created() {
    const { initialize } = this;
    initialize();
  },
  computed: {
    isPC() {
      return !isMobile().any;
    },
  },
  methods: {
    initialize() {
      const { novelId, genreList, categoryList, workStatusList } = this;
      const { getters } = this.$store;
      const novel = getters["novelModule/novel"](novelId) as Novel;
      this.novel = { ...novel };

      const { genre, category, workStatus, image } = novel;
      if (genre) {
        this.genre = genreList.find((item) => item.id === genre) ?? null;
      }
      if (category) {
        this.category = categoryList.filter((item) => category.includes(item.id));
      }
      if (workStatus) {
        this.workStatus =
          workStatusList.find((x) => x.id === workStatus) ?? workStatusList.find((x) => x.id === "inProgress")!;
      }
      if (image) {
        this.image = image;
      }
    },
    change() {
      this.setModified(true);
    },
    imagePath() {
      const { novel, novelId } = this;

      if (!novel) {
        return null;
      }

      const { image } = this;
      if (!image) {
        return null;
      }

      if (image.startsWith("file:")) {
        return `file:novels/${novelId}/cover.jpg`;
      }

      if (image.startsWith("preset:")) {
        return image;
      }

      return null;
    },
    async submit() {
      const { novelId, novel, showErrorDialog } = this;

      if (!novel) {
        showErrorDialog("更新する作品が取得できません。");
        return;
      }

      const { title, description } = novel;
      const { genre, category, workStatus, image } = this;
      let genreId;
      let categoryIds;
      let workStatusId;

      if (genre) {
        genreId = genre.id;
      }

      if (category) {
        categoryIds = category.map((x) => x.id);
      }

      if (workStatus) {
        workStatusId = workStatus.id;
      }

      await submitImage(`novels/${novelId}/cover.jpg`);
      const { dispatch } = this.$store;
      await dispatch("novelModule/updateNovel", {
        novelId,
        title,
        image,
        description,
        genre: genreId,
        category: categoryIds,
        workStatus: workStatusId,
      });
      this.setModified(false);
      this.$router.push({ name: "detail", params: { novelId } });
    },
    selectGenre(item) {
      this.genre = item;
      this.change();
    },
    unselectGenre() {
      this.genre = null;
      this.change();
    },
    selectCategory(item: NovelParam[]) {
      this.category = item.length ? item : null;
      this.change();
    },
    selectWorkStatus(item) {
      this.workStatus = item;
      this.change();
    },
    showErrorDialog(message: string) {
      const confirmDialog = new Dialog(DialogVue);
      const options = {
        title: "エラー",
        content: message,
      };

      confirmDialog.show(options);
    },
  },
});
